// Puerto verbatim de packages/hce/src/hce/offline/readCache.ts.
import { idbGet, idbPut, STORE_READ_CACHE } from './db';

interface EntradaCache {
  url: string;
  cuerpo: unknown;
  guardadoEn: string;
}

export async function guardarEnCache(url: string, cuerpo: unknown): Promise<void> {
  await idbPut<EntradaCache>(STORE_READ_CACHE, { url, cuerpo, guardadoEn: new Date().toISOString() });
}

export interface ResultadoCache {
  cuerpo: unknown;
  guardadoEn: string;
}

export async function leerDeCache(url: string): Promise<ResultadoCache | undefined> {
  const entrada = await idbGet<EntradaCache>(STORE_READ_CACHE, url);
  return entrada ? { cuerpo: entrada.cuerpo, guardadoEn: entrada.guardadoEn } : undefined;
}
